<section class="flex flex-col items-center gap-12">
  <div class="text-center">
    <h2 class="mb-4 text-3xl font-bold">Our Values</h2>
    <p class="max-w-2xl text-lg text-gray-600">
      Our core principles guide everything we do and define who we are as a
      team.
    </p>
  </div>

  <div class="grid w-full grid-cols-1 gap-8 sm:grid-cols-2">
    <!-- Customers First -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.users" class="mr-2" />
        <h3 class="text-xl font-bold">Customers First</h3>
      </div>
      <p class="text-pretty text-lg">
        We focus on customer success and deliver products that exceed
        expectations. Every decision we make is centered around providing value
        to our users.
      </p>
    </div>

    <!-- Security by Design -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.shield-check" class="mr-2" />
        <h3 class="text-xl font-bold">Security by Design</h3>
      </div>
      <p class="text-pretty text-lg">
        We emphasize trust and transparency in everything we build. We regularly
        audit our infrastructure and codebase to ensure the highest security
        standards.
      </p>
    </div>

    <!-- Act as an Owner -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.crown" class="mr-2" />
        <h3 class="text-xl font-bold">Act as an Owner</h3>
      </div>
      <p class="text-pretty text-lg">
        We empower team members to make decisions and take ownership of their
        work. We minimize unnecessary meetings and focus on meaningful
        collaboration.
      </p>
    </div>

    <!-- Don't Stop Shipping -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.rocket" class="mr-2" />
        <h3 class="text-xl font-bold">Don't Stop Shipping</h3>
      </div>
      <p class="text-pretty text-lg">
        We prioritize continuous growth and improvement. Our motto is "ship fast
        and iterate faster" to deliver value to our customers quickly and
        efficiently.
      </p>
    </div>
  </div>
</section>
